module.exports = __webpack_public_path__ + "img/cv.5957616b.svg";